import Vue from 'vue';

export const BusEvent = new Vue();

export enum BusEventTargets {
  CONFIRM_DIALOG_FAVORITE = 'confirmation-dialog-favorite',
  FORM_DIALOG_FAVORITE = 'form-dialog-favorite',
  FORM_DIALOG_LINK = 'form-dialog-link',
  FORM_DIALOG_LINK_ITEM = 'form-dialog-link-item',
  UPLOAD_ON_EXECUTE_DIALOG = 'upload-on-execute-dialog',
}
